module.exports = __webpack_public_path__ + "img/HSR-2-Head-Template-Replicator.31f46cb7.jpg";